/** Sentinel used in field lists to mark where custom properties go. */
export const CUSTOM_PROPERTIES = Symbol('customProperties')

/** Expand CUSTOM_PROPERTIES sentinels in a field array using dv.customProperties. */
export function expandCustomProperties(fields, customProperties) {
  return fields.flatMap((entry) => {
    if (entry === CUSTOM_PROPERTIES) {
      return (customProperties || []).map(({ name }) => [name])
    }
    return [entry]
  })
}
